var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4565"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.151,
    x2: 390.151,
    xlinkHref: "#lg1",
    y1: 39.815,
    y2: 497.498
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022545453014983059370000005276882704817044636_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.475,
    x2: 502.329,
    xlinkHref: "#lg2",
    y1: 289.497,
    y2: 338.871
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074413936709724795110000005580104005047236786_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.151,
    x2: 390.151,
    xlinkHref: "#lg2",
    y1: 269.051,
    y2: 476.702
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072239920756184373200000014853537873628330898_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.954,
    x2: 425.495,
    xlinkHref: "#lg1",
    y1: 178.714,
    y2: 346.429
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047779483847814115930000001928998902922544308_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.063,
    x2: 222.974,
    xlinkHref: "#lg2",
    y1: 345.554,
    y2: 255.019
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111154227126379997430000003861680436715729796_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.301,
    x2: 268.301,
    xlinkHref: "#lg2",
    y1: 373.677,
    y2: 508.011
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012454804932498589140000004561741772513351073_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.426,
    x2: 144.961,
    xlinkHref: "#lg2",
    y1: 326.341,
    y2: 299.252
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038395701794121386980000007940630942563387806_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.684,
    x2: 433.256,
    xlinkHref: "#lg2",
    y1: 300.744,
    y2: 384.21
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbd5ef"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057128932954103807870000011480462904261931195_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.937,
    x2: 397.433,
    xlinkHref: "#lg3",
    y1: 192.511,
    y2: 330.286
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069396529985512466430000000387680772175982227_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.949,
    x2: 343.597,
    xlinkHref: "#lg3",
    y1: 218.98,
    y2: 299.315
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbd5ef",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#d9d2ee",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#d4c9e9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#cbbae2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#bfa5d7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#af8aca",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a274bf"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002368282113258605330000003556970419458960552_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.205,
    x2: 244.047,
    xlinkHref: "#lg4",
    y1: 296.495,
    y2: 247.069
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183233631465282135480000017610152878312672938_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.301,
    x2: 164.46,
    xlinkHref: "#lg4",
    y1: 316.27,
    y2: 290.606
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3dafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109713527386965080140000012688987498271691676_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.783,
    x2: 91.783,
    xlinkHref: "#lg5",
    y1: 175.857,
    y2: 232.088
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#314dc9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2761,
    stopColor: "#304bc4",
    stopOpacity: 0.276
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5628,
    stopColor: "#2b45b8",
    stopOpacity: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8535,
    stopColor: "#243ba3",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3596"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005262650479471141810000017076141926354391938_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.515,
    x2: 100.515,
    xlinkHref: "#lg6",
    y1: 224.63,
    y2: 249.59
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021808870262241651650000003906058651475134882_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.368,
    x2: 71.487,
    xlinkHref: "#lg6",
    y1: 225.329,
    y2: 247.428
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175320160311299056920000014745670233875561390_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.063,
    x2: 87.746,
    xlinkHref: "#lg6",
    y1: 214.767,
    y2: 242.213
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040561515559875127780000010591871972778066081_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.162,
    x2: 83.588,
    xlinkHref: "#lg6",
    y1: 216.634,
    y2: 230.535
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120538811295188035430000012805151514958826677_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.059,
    x2: 148.237,
    xlinkHref: "#lg6",
    y1: 211.487,
    y2: 201.506
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144316736341368622620000004546374131448984716_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.635,
    x2: 108.348,
    xlinkHref: "#lg5",
    y1: 266.431,
    y2: 324.53
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051347431032520249160000011222024670627655342_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.777,
    x2: 76.777,
    xlinkHref: "#lg6",
    y1: 322.65,
    y2: 350.208
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100345778608039665820000005337393739743088314_",
    gradientTransform: "matrix(1 0 0 -1 0 409.57)",
    gradientUnits: "userSpaceOnUse",
    x1: 95.368,
    x2: 71.487,
    xlinkHref: "#lg6",
    y1: 122.899,
    y2: 144.998
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082330375363151940460000012279319491716149917_",
    gradientTransform: "matrix(1 0 0 -1 0 409.57)",
    gradientUnits: "userSpaceOnUse",
    x1: 108.063,
    x2: 87.746,
    xlinkHref: "#lg6",
    y1: 112.337,
    y2: 139.782
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168837206974803689600000001288290193197825960_",
    gradientTransform: "matrix(1 0 0 -1 0 409.57)",
    gradientUnits: "userSpaceOnUse",
    x1: 118.162,
    x2: 83.588,
    xlinkHref: "#lg6",
    y1: 114.204,
    y2: 128.105
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058588509465674334330000012509857427566994818_",
    gradientTransform: "matrix(1 0 0 -1 0 409.57)",
    gradientUnits: "userSpaceOnUse",
    x1: 130.059,
    x2: 148.237,
    xlinkHref: "#lg6",
    y1: 109.056,
    y2: 99.076
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135672159176607581930000004143922200776682393_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.072,
    x2: 137.072,
    y1: 245.416,
    y2: 262.658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m326.085 21.162h-57.783v469.675h57.783c102.67.001 185.915-105.144 185.915-234.837s-83.245-234.838-185.915-234.838z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.085 21.162h-57.783v469.675h57.783c102.67.001 185.915-105.144 185.915-234.837s-83.245-234.838-185.915-234.838z",
    fill: "url(#SVGID_00000022545453014983059370000005276882704817044636_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.301 490.838h57.783c102.671 0 185.916-105.145 185.916-234.838 0-11.483-.665-22.769-1.926-33.811h-241.773z",
    fill: "url(#SVGID_00000074413936709724795110000005580104005047236786_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.301,
    cy: 256,
    fill: "url(#SVGID_00000072239920756184373200000014853537873628330898_)",
    rx: 185.913,
    ry: 234.836
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.28 246.274h-187.721c-.104 3.227-.171 6.467-.171 9.726 0 129.697 83.236 234.836 185.913 234.836 61.685 0 116.343-37.958 150.162-96.379z",
    fill: "url(#SVGID_00000047779483847814115930000001928998902922544308_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.388 256c0 129.697 83.236 234.836 185.913 234.836s185.913-105.139 185.913-234.836c0-4.697-.122-9.358-.337-13.987h-371.151c-.216 4.629-.338 9.29-.338 13.987z",
    fill: "url(#SVGID_00000111154227126379997430000003861680436715729796_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.248 242.013h-145.522c-.215 4.629-.337 9.29-.337 13.987 0 112.325 62.437 206.213 145.859 229.354z",
    fill: "url(#SVGID_00000012454804932498589140000004561741772513351073_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.301 21.164c-10.439 0-20.671 1.104-30.641 3.193v463.287c9.97 2.089 20.203 3.193 30.641 3.193 102.677 0 185.913-105.14 185.913-234.836s-83.236-234.837-185.913-234.837z",
    fill: "url(#SVGID_00000038395701794121386980000007940630942563387806_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.301 63.082c-84.344 0-152.725 86.378-152.725 192.918s68.381 192.918 152.725 192.918 152.726-86.378 152.726-192.918-68.381-192.918-152.726-192.918zm0 347.259c-67.48 0-122.185-69.107-122.185-154.341s54.705-154.341 122.185-154.341 122.185 69.106 122.185 154.341-54.705 154.341-122.185 154.341z",
    fill: "url(#SVGID_00000057128932954103807870000011480462904261931195_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.301 143.512c-49.186 0-89.049 50.362-89.049 112.488s39.863 112.488 89.049 112.488 89.05-50.362 89.05-112.488-39.864-112.488-89.05-112.488zm0 179.891c-29.474 0-53.364-30.178-53.364-67.403s23.889-67.403 53.364-67.403 53.364 30.178 53.364 67.403-23.889 67.403-53.364 67.403z",
    fill: "url(#SVGID_00000069396529985512466430000000387680772175982227_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.27 290.26c-9.29 19.84-26.4 33.14-45.97 33.14-29.47 0-53.36-30.18-53.36-67.4 0-3.31.19-6.56.55-9.73h-35.9c-.23 3.21-.34 6.45-.34 9.73 0 62.13 39.87 112.49 89.05 112.49 30.92 0 58.15-19.89 74.1-50.1z",
    fill: "url(#SVGID_00000002368282113258605330000003556970419458960552_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m368.44 344.44c-22.09 39.85-58.71 65.9-100.14 65.9-67.48 0-122.18-69.11-122.18-154.34 0-3.27.08-6.51.24-9.73h-30.59c-.13 3.22-.19 6.47-.19 9.73 0 106.54 68.38 192.92 152.72 192.92 51.14 0 96.4-31.75 124.13-80.49z",
    fill: "url(#SVGID_00000183233631465282135480000017610152878312672938_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m183.567 256h-128.08l-53.79-76.65c-4.31-6.14.09-14.6 7.59-14.6h5.56c5.43 0 10.52 2.64 13.63 7.09l12.37 17.62-4.83-16.94c-1.11-3.89 1.81-7.77 5.86-7.77h22.112c1.06 0 2.081.398 2.861 1.116l3.187 2.931c1.376 1.266 3.42 1.477 5.026.519 1.285-.766 2.879-.796 4.192-.079l4.989 2.726c1.96 1.071 4.394.691 5.934-.927 4.132-4.342 10.316-6.035 16.099-4.46 11.486 3.129 21.682 10.175 28.68 20.153z",
    fill: "url(#SVGID_00000109713527386965080140000012688987498271691676_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.487 256h128.08l-38.023-54.182h-128.08z",
    fill: "url(#SVGID_00000005262650479471141810000017076141926354391938_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 186.73c-6.999-9.978-17.194-17.024-28.68-20.153-5.783-1.575-11.967.118-16.099 4.46-1.54 1.618-3.974 1.998-5.934.927l-4.989-2.726c-1.313-.718-2.907-.688-4.192.078-1.606.957-3.65.746-5.026-.519l-3.187-2.931c-.78-.718-1.801-1.116-2.861-1.116h-22.112c-4.05 0-6.97 3.88-5.86 7.77l4.731 16.593 46.937 66.887h95.881z",
    fill: "url(#SVGID_00000021808870262241651650000003906058651475134882_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 186.73c-6.999-9.978-17.194-17.024-28.68-20.153-5.783-1.575-11.967.118-16.099 4.46-1.54 1.618-3.974 1.998-5.934.927l-4.989-2.726c-1.313-.718-2.907-.688-4.192.078-1.606.957-3.65.746-5.026-.519l-3.187-2.931c-.78-.718-1.801-1.116-2.861-1.116h-22.112c-1.465 0-2.778.513-3.81 1.345.879.091 1.757.245 2.626.482 11.486 3.129 21.682 10.175 28.68 20.153l48.61 69.27h65.584z",
    fill: "url(#SVGID_00000175320160311299056920000014745670233875561390_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 186.73c-6.999-9.978-17.194-17.024-28.68-20.153-5.783-1.575-11.967.118-16.099 4.46-1.54 1.618-3.974 1.998-5.934.927l-4.989-2.726c-1.313-.718-2.907-.688-4.192.078-1.072.639-2.336.746-3.469.378 7.998 3.771 15.008 9.585 20.234 17.036l48.61 69.27h43.129z",
    fill: "url(#SVGID_00000040561515559875127780000010591871972778066081_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 186.73c-6.999-9.978-17.194-17.024-28.68-20.153-5.783-1.575-11.967.118-16.099 4.46-1.54 1.618-3.974 1.998-5.934.927l-4.989-2.726c-1.313-.718-2.907-.688-4.192.078-1.072.639-2.336.746-3.469.378 7.998 3.771 15.008 9.585 20.234 17.036l48.61 69.27h43.129z",
    fill: "url(#SVGID_00000120538811295188035430000012805151514958826677_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m183.567 256h-128.08l-53.79 76.65c-4.31 6.14.09 14.6 7.59 14.6h5.56c5.43 0 10.52-2.64 13.63-7.09l12.37-17.62-4.83 16.94c-1.11 3.89 1.81 7.77 5.86 7.77h22.112c1.06 0 2.081-.398 2.861-1.116l3.187-2.931c1.376-1.266 3.42-1.477 5.026-.519 1.285.766 2.879.796 4.192.079l4.989-2.726c1.96-1.071 4.394-.691 5.934.927 4.132 4.342 10.316 6.035 16.099 4.46 11.486-3.129 21.682-10.175 28.68-20.153z",
    fill: "url(#SVGID_00000144316736341368622620000004546374131448984716_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.473 298.768-23.776 33.882c-4.31 6.14.09 14.6 7.59 14.6h5.56c5.43 0 10.52-2.64 13.63-7.09l12.37-17.62-4.83 16.94c-1.11 3.89 1.81 7.77 5.86 7.77h22.112c1.06 0 2.081-.398 2.861-1.116l3.187-2.931c1.376-1.266 3.42-1.477 5.026-.519 1.285.766 2.879.796 4.192.079l4.989-2.726c1.96-1.071 4.394-.691 5.934.927 4.132 4.342 10.316 6.035 16.099 4.46 11.486-3.129 21.682-10.175 28.68-20.153l18.597-26.502h-128.081z",
    fill: "url(#SVGID_00000051347431032520249160000011222024670627655342_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 325.27c-6.999 9.978-17.194 17.024-28.68 20.153-5.783 1.575-11.967-.118-16.099-4.46-1.54-1.618-3.974-1.998-5.934-.927l-4.989 2.726c-1.313.718-2.907.688-4.192-.078-1.606-.957-3.65-.746-5.026.519l-3.187 2.931c-.78.718-1.801 1.116-2.861 1.116h-22.112c-4.05 0-6.97-3.88-5.86-7.77l4.731-16.593 46.937-66.887h95.881z",
    fill: "url(#SVGID_00000100345778608039665820000005337393739743088314_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 325.27c-6.999 9.978-17.194 17.024-28.68 20.153-5.783 1.575-11.967-.118-16.099-4.46-1.54-1.618-3.974-1.998-5.934-.927l-4.989 2.726c-1.313.718-2.907.688-4.192-.078-1.606-.957-3.65-.746-5.026.519l-3.187 2.931c-.78.718-1.801 1.116-2.861 1.116h-22.112c-1.465 0-2.778-.513-3.81-1.345.879-.091 1.757-.245 2.626-.482 11.486-3.129 21.682-10.175 28.68-20.153l48.61-69.27h65.584z",
    fill: "url(#SVGID_00000082330375363151940460000012279319491716149917_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 325.27c-6.999 9.978-17.194 17.024-28.68 20.153-5.783 1.575-11.967-.118-16.099-4.46-1.54-1.618-3.974-1.998-5.934-.927l-4.989 2.726c-1.313.718-2.907.688-4.192-.078-1.072-.639-2.336-.746-3.469-.378 7.998-3.771 15.008-9.585 20.234-17.036l48.61-69.27h43.129z",
    fill: "url(#SVGID_00000168837206974803689600000001288290193197825960_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.957 325.27c-6.999 9.978-17.194 17.024-28.68 20.153-5.783 1.575-11.967-.118-16.099-4.46-1.54-1.618-3.974-1.998-5.934-.927l-4.989 2.726c-1.313.718-2.907.688-4.192-.078-1.072-.639-2.336-.746-3.469-.378 7.998-3.771 15.008-9.585 20.234-17.036l48.61-69.27h43.129z",
    fill: "url(#SVGID_00000058588509465674334330000012509857427566994818_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m274.143 256v.144c-.006 7.649-6.209 13.846-13.858 13.846h-246.295c-7.726 0-13.99-6.263-13.99-13.99 0-7.726 6.264-13.99 13.99-13.99h246.296c7.649 0 13.851 6.197 13.858 13.846z",
    fill: "url(#SVGID_00000135672159176607581930000004143922200776682393_)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DTarget);
export default __webpack_public_path__ + "static/media/3dTarget.e6c654325e5b68e1ba3b972a29ae9902.svg";
export { ForwardRef as ReactComponent };